module.exports = __webpack_public_path__ + "img/c01_unitmerchanttransport_Normal_ua.047ade1a.webp";